import { faRankingStar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { type ReactElement, useContext } from 'react'
import { AsideActionContext } from '~/utils/contextes'
import { useApplicantShortlistFeedback } from '../queries/orderShortlistFeedbacks'
import { rankBadge, rankBadgeAnswer } from './ShortlistRankBadge.css'
import { ShortlistReportAside } from './ShortlistReportAside'

type ShortlistRankBadgeProps = {
  orderId?: number
  applicantId: number
}

export const ShortlistRankBadge = ({
  orderId,
  applicantId
}: ShortlistRankBadgeProps): ReactElement | null => {
  const feedback = useApplicantShortlistFeedback(orderId, applicantId)
  const { asideAction, setAsideAction } = useContext(AsideActionContext)
  if (!feedback) {
    return null
  }

  const answer =
    feedback.accepted === null ? 'none' : feedback.accepted ? 'yes' : 'no'

  return (
    <button
      type="button"
      className={clsx(rankBadge, rankBadgeAnswer[answer])}
      aria-label="Voir le dernier retour client"
      onClick={(event) => {
        event.stopPropagation()
        setAsideAction({
          action: <ShortlistReportAside shortlistId={feedback.shortlistId} />,
          returnTo: asideAction ?? undefined
        })
      }}
    >
      <FontAwesomeIcon icon={faRankingStar} />
      {feedback.rank}/{feedback.total}
    </button>
  )
}
